var events = require('../../../../main/scripts/modules/utils/events');

var Parameters = {
    EVENT: 'event',
    FORMTYPE: 'formType',
    FORMSTEP: 'formStep',
    STEPTYPE: 'stepType',
    MEMBER: 'member',
    ECOMMERCE: 'ecommerce',
    VALUE: 'value',
    ITEMNAME: 'itemName',
    ITEMTYPE: 'itemType',
    MARKETING_PREFERENCES: 'marketing_preferences',
    DOCUMENT_PREFERENCES: 'document_preferences',
    PEOPLE_COVERED: 'peopleCovered',
    TRANSACTION_ID: 'transaction_id',
    FACILITY: 'hospital',
    TREATMENT_TYPE: 'treatmentType',
    DESTINATION: 'destination',
    ADDON: 'addOn'
};

var Items = {

    PMI_CODE: 'PMI0811',
    DENTAL_PLUS: 'dental_plus',
    DENTAL_STANDARD: 'dental'

};

var GLOBAL_CONFIG = {
    Debug: true,
    GA: {
        STAGING: 'XYZ',
        PRODUCTION: 'ABC',
    },
    GTM: {
        STAGING: 'XYZ',
        PRODUCTION: 'ABC',
    },
    Parameters : Parameters,
    Items: Items,
    Journeys : {
        GROUP_TRANSFER: 'group_transfer',
        GROUP_JOIN: 'group_join',
        INT_GROUP_JOIN: 'int_group_join'
    },
    Forms:{
        Events: {
            FormEvents : events.FormEvents,
            FormStepTypes: events.FormStepTypes
        }
    }
};

module.exports = {
    GLOBAL_CONFIG : GLOBAL_CONFIG,
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/globalAnalyticsConfig.js
// module id = TNSw
// module chunks = 0 1 2 3 5 6 9 10 11 12 13 14